/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_File_JpgpngpdfInputs */

const en_upload_file_jpgpngpdf = /** @type {(inputs: Upload_File_JpgpngpdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload file (JPG/PNG/PDF)`)
};

const es_upload_file_jpgpngpdf = /** @type {(inputs: Upload_File_JpgpngpdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir archivo (JPG/PNG/PDF)`)
};

const fr_upload_file_jpgpngpdf = /** @type {(inputs: Upload_File_JpgpngpdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger un fichier (JPG/PNG/PDF)`)
};

const de_upload_file_jpgpngpdf = /** @type {(inputs: Upload_File_JpgpngpdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei hochladen (JPG/PNG/PDF)`)
};

const ja_upload_file_jpgpngpdf = /** @type {(inputs: Upload_File_JpgpngpdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルをアップロード (JPG/PNG/PDF)`)
};

const zh_upload_file_jpgpngpdf = /** @type {(inputs: Upload_File_JpgpngpdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传文件 (JPG/PNG/PDF)`)
};

const ar_upload_file_jpgpngpdf = /** @type {(inputs: Upload_File_JpgpngpdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحميل ملف (JPG/PNG/PDF)`)
};

const id_upload_file_jpgpngpdf = /** @type {(inputs: Upload_File_JpgpngpdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah file (JPG/PNG/PDF)`)
};

const it_upload_file_jpgpngpdf = /** @type {(inputs: Upload_File_JpgpngpdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica file (JPG/PNG/PDF)`)
};

const ru_upload_file_jpgpngpdf = /** @type {(inputs: Upload_File_JpgpngpdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузить файл (JPG/PNG/PDF)`)
};

const pt_upload_file_jpgpngpdf = /** @type {(inputs: Upload_File_JpgpngpdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer upload do arquivo (JPG/PNG/PDF)`)
};

const ko_upload_file_jpgpngpdf = /** @type {(inputs: Upload_File_JpgpngpdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파일 업로드 (JPG/PNG/PDF)`)
};

/**
* | output |
* | --- |
* | "Upload file (JPG/PNG/PDF)" |
*
* @param {Upload_File_JpgpngpdfInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upload_file_jpgpngpdf = /** @type {((inputs?: Upload_File_JpgpngpdfInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_File_JpgpngpdfInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_file_jpgpngpdf(inputs)
	if (locale === "es") return es_upload_file_jpgpngpdf(inputs)
	if (locale === "fr") return fr_upload_file_jpgpngpdf(inputs)
	if (locale === "de") return de_upload_file_jpgpngpdf(inputs)
	if (locale === "ja") return ja_upload_file_jpgpngpdf(inputs)
	if (locale === "zh") return zh_upload_file_jpgpngpdf(inputs)
	if (locale === "ar") return ar_upload_file_jpgpngpdf(inputs)
	if (locale === "id") return id_upload_file_jpgpngpdf(inputs)
	if (locale === "it") return it_upload_file_jpgpngpdf(inputs)
	if (locale === "ru") return ru_upload_file_jpgpngpdf(inputs)
	if (locale === "pt") return pt_upload_file_jpgpngpdf(inputs)
	return ko_upload_file_jpgpngpdf(inputs)
});